var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upoladSuccessStyle"},[_c('div',{staticClass:"uploadInvoiceStyle"},[_c('InvoiceComponent',{attrs:{"invoiceData":_vm.invoiceData}})],1),_c('div',{staticClass:"footerButtonBox"},[_c('FooterTwoButton',{attrs:{"leftNext":_vm.goback,"rightNext":_vm.continueUploadFc,"left":"返回","right":"继续上传","repay":_vm.repay}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }